export function readPageQuery() {
  const query = Object.create(null);
  new URLSearchParams(window.location.search).forEach((value, key) => {
    query[key] = query[key] === undefined ? value : [].concat(query[key], value);
  });
  return query;
}

export function pageQueryUrl(query) {
  const params = new URLSearchParams();
  Object.entries(query).forEach(([key, value]) => {
    const values = Array.isArray(value) ? value : [value];
    values.forEach((entry) => params.append(key, entry));
  });
  const queryString = params.toString().replace(/%2C/gi, ',');
  return window.location.pathname + (queryString ? `?${queryString}` : '');
}

export function replacePageQuery(query) {
  // Router navigation would remount App.vue's fullPath-keyed router-view.
  window.history.replaceState(window.history.state, '', pageQueryUrl(query));
}
